export const COMPASSUS_HH_RPM_BETA_FEATURE = "HH-RPM";
export const COMPASSUS_HH_RPM_SLIM_BETA_FEATURE = "HH-RPM-SLIM";
export const COMPASSUS_HH_RPM_SLIM_PREVIEW_KEY = "hhRpmSlimPreview";
export const COMPASSUS_HH_RPM_SLIM_PREVIEW_EVENT = "hhRpmSlimPreviewChange";

const hasBetaFeature = (
  betaFeaturesAllowedList: readonly string[],
  featureName: string
): boolean =>
  betaFeaturesAllowedList.some(
    (feature) => feature.toLowerCase() === featureName.toLowerCase()
  );

export const hasCompassusHhRpmBetaFeature = (
  betaFeaturesAllowedList: string[] = []
): boolean =>
  hasCompassusHhRpmRegularBetaFeature(betaFeaturesAllowedList) ||
  hasBetaFeature(betaFeaturesAllowedList, COMPASSUS_HH_RPM_SLIM_BETA_FEATURE);

export const hasCompassusHhRpmRegularBetaFeature = (
  betaFeaturesAllowedList: string[] = []
): boolean =>
  hasBetaFeature(betaFeaturesAllowedList, COMPASSUS_HH_RPM_BETA_FEATURE);

export const hasCompassusHhRpmSlimBetaFeature = (
  betaFeaturesAllowedList: string[] = []
): boolean =>
  hasBetaFeature(betaFeaturesAllowedList, COMPASSUS_HH_RPM_SLIM_BETA_FEATURE);

export const isCompassusHhRpmSlimPreviewEnabled = (): boolean => {
  try {
    return (
      typeof window !== "undefined" &&
      window.sessionStorage.getItem(COMPASSUS_HH_RPM_SLIM_PREVIEW_KEY) ===
        "true"
    );
  } catch {
    return false;
  }
};

export const setCompassusHhRpmSlimPreview = (enabled: boolean): void => {
  try {
    window.sessionStorage.setItem(
      COMPASSUS_HH_RPM_SLIM_PREVIEW_KEY,
      enabled ? "true" : "false"
    );
    window.dispatchEvent(
      new CustomEvent(COMPASSUS_HH_RPM_SLIM_PREVIEW_EVENT, {
        detail: { enabled },
      })
    );
  } catch {
    // Preview mode is optional; ignore unavailable browser storage.
  }
};

export const isCompassusHhRpmClinic = (
  clinic?: Pick<IClinic, "config"> | null,
  betaFeaturesAllowedList: string[] = []
): boolean => {
  if (!clinic) return false;
  if (!hasCompassusHhRpmBetaFeature(betaFeaturesAllowedList)) {
    return false;
  }
  return clinic.config?.isHomeHealthRPM === true;
};

export const isCompassusHhRpmSlimClinic = (
  clinic?: Pick<IClinic, "config"> | null,
  betaFeaturesAllowedList: string[] = []
): boolean =>
  clinic?.config?.isHomeHealthRPM === true &&
  (hasCompassusHhRpmSlimBetaFeature(betaFeaturesAllowedList) ||
    (hasCompassusHhRpmRegularBetaFeature(betaFeaturesAllowedList) &&
      isCompassusHhRpmSlimPreviewEnabled()));
